import request from '@/utils/request'

// 设备新手指引
export function getGuide (identity, language) {
  return request({
    url: '/device/guide',
    method: 'POST',
    params: { identity, language }
  })
}

// 分享
export function getShare (identity) {
  return request({
    url: '/user/device/brew/share/info',
    method: 'POST',
    params: { identity }
  })
}



// WEBPACK FOOTER //
// ./src/api/public.js